import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { createPortal } from 'react-dom';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  // Close on Escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return createPortal(<AnimatePresence data-id="element-205">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-206">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-207" />

          {/* Modal Content */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.2,
        ease: 'easeOut'
      }} className="relative w-full max-w-2xl max-h-[85vh] overflow-hidden rounded-2xl bg-[#1a1f2e] border border-[#2a3245] shadow-2xl flex flex-col" onClick={e => e.stopPropagation()} data-id="element-208">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-[#2a3245] bg-[#1a1f2e] sticky top-0 z-10" data-id="element-209">
              <h2 className="text-xl font-serif font-bold text-[#f5f0e8]" data-id="element-210">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 rounded-full text-gray-400 hover:text-[#d4af37] hover:bg-[#2a3245] transition-colors" aria-label="Cerrar" data-id="element-211">
                <X size={20} data-id="element-212" />
              </button>
            </div>

            {/* Scrollable Content */}
            <div className="p-6 overflow-y-auto text-gray-300 leading-relaxed space-y-4 custom-scrollbar" data-id="element-213">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>, document.body);
}